var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 2.95255C0.400391 2.33478 0.616613 1.82513 1.04904 1.4236C1.48147 1.02205 2.04364 0.821289 2.73553 0.821289C3.41507 0.821289 3.96486 1.01896 4.38495 1.41434C4.81737 1.82205 5.03359 2.35331 5.03359 3.00815C5.03359 3.60119 4.82356 4.09539 4.40348 4.49076C3.97105 4.89848 3.40271 5.10234 2.69846 5.10234H2.67993C2.00038 5.10234 1.45059 4.89848 1.03051 4.49076C0.610423 4.08304 0.400391 3.5703 0.400391 2.95255ZM0.641317 19.1687V6.78882H4.7556V19.1687H0.641317ZM7.03514 19.1687H11.1494V12.256C11.1494 11.8235 11.1988 11.4899 11.2977 11.2552C11.4707 10.8351 11.7332 10.4799 12.0853 10.1896C12.4375 9.89922 12.8791 9.75405 13.4104 9.75405C14.7942 9.75405 15.4861 10.6869 15.4861 12.5525V19.1687H19.6004V12.0706C19.6004 10.2421 19.168 8.85521 18.3031 7.91005C17.4382 6.96488 16.2954 6.49229 14.8745 6.49229C13.2807 6.49229 12.039 7.178 11.1494 8.54942V8.58649H11.1309L11.1494 8.54942V6.78882H7.03514C7.05984 7.18418 7.0722 8.41351 7.0722 10.4768C7.0722 12.5401 7.05984 15.4374 7.03514 19.1687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5b5a6e8a4b0d4874cca6d01e5a0cff7d.svg";
export { ForwardRef as ReactComponent };